const FileManager = () =>
  import(
    /* webpackChunkName: "site-file-and-documents" */ '@/pages/site-generator/file-and-documents/index.vue'
  )
const FileManagerEdit = () =>
  import(
    /* webpackChunkName: "site-file-and-documents" */ '@/pages/site-generator/file-and-documents/media.vue'
  )

export default {
  path: 'file-and-documents',
  meta: {
    label: 'doc',
    auth: 'doc'
  },
  component: {
    name: 'Doc',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'SiteFileAndDocuments',
      path: '',
      meta: {
        label: 'fileAndDocuments',
        auth: 'root'
      },
      component: FileManager
    },
    {
      name: 'SiteEditFileAndDocuments',
      path: ':root',
      meta: {
        label: 'edit',
        auth: 'root'
      },
      props: true,
      component: FileManagerEdit
    }
  ]
}
